<template>
    <div class="Slider">

    </div>
</template>

<script>
    export default {
        name:'slider',
        props: {
            content: Object
        },
        created() {
        }
    }
</script>

<style lang="scss">

</style>



